import Center from '../../assets/styles/Center';
import Search from '../Search';
import LinkDesktop from './components/LinkDesktop';
import LinkMobile from './components/LinkMobile';
import Logo from './components/Logo';
import * as styles from './styles';

export default function Header() {
  return (
    <styles.Container>
      <Center>
        <Logo />

        <Search small />

        <LinkDesktop />
        <LinkMobile />
      </Center>

      <Search mobile />
    </styles.Container>
  );
}
